import React from 'react';
import { Logo } from '../../AssetComponents/Images';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SignIn from '../../Components/OnBoarding/SignIn';
import { useOnboarding } from './OnBoarding1';

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { startOnboarding } = useOnboarding();

  return (
 <header className="w-full border-b border-gray-100 px-4 sm:px-6 py-3">
  <div className="flex flex-wrap sm:flex-nowrap items-center justify-between w-full">
    <div className="flex items-center gap-2">
      <Logo onClick={() => navigate('/')} className="cursor-pointer" />
    </div>
    <nav className="flex flex-wrap items-center justify-end gap-4 text-sm sm:text-base">
      <button onClick={() => navigate('/rent/onboarding/about')} className="text-gray-600 hover:text-gray-900">
        About
      </button>
      <SignIn dispatch={dispatch} navigate={navigate} startOnboarding={startOnboarding} />
    </nav>
  </div>
</header>

  );
}

export default Header;
